<template>
  <div class="invitations">
    <h1 class="invitations__title page-title">
      Invitations
    </h1>

    <el-tabs
      v-model="activeTab" readonly
      class="events__tabs"
      @tab-click="handleChangeTab"
    >
      <el-tab-pane label="Events" name="events" lazy>
        <div class="invitations__list card">
          <div
            class="invitations__empty-text"
            v-if="eventInvitationArray.length === 0"
          >
            No invitations
          </div>
          <div
            v-for="(invitation, index) in eventInvitationArray"
            :key="invitation.invitationId"
          >
            <event-invitation-preview
              :invitation-data="invitation"
              @update-data="fetchEventInvitations"
            />
            <el-divider v-if="index < eventInvitationArray.length - 1" />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Teams" name="teams" lazy>
        <div class="invitations__list card">
          <div
            class="invitations__empty-text"
            v-if="teamInvitationArray.length === 0"
          >
            No invitations
          </div>

          <div
            v-for="(invitation, index) in teamInvitationArray"
            :key="invitation.invitationId"
          >
            <team-invitation-preview
              :invitation-data="invitation"
              @update-data="fetchTeamInvitations"
            />
            <el-divider v-if="index < teamInvitationArray.length - 1" />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getIncomingUserInvitations } from '@/api/invitation.js';
import { getIncomingUserTeamInvitations } from '@/api/team.js';

import EventInvitationPreview from '@/components/invitations/EventInvitationPreview.vue';
import TeamInvitationPreview from '@/components/invitations/TeamInvitationPreview.vue';

export default {
  name: 'Invitations',
  components: {
    EventInvitationPreview,
    TeamInvitationPreview,
  },
  data() {
    return {
      eventInvitationArray: [],
      teamInvitationArray: [],
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$route.query.tab || 'events';
      },
      set(value) {
        this.$router.push({
          query: {
            tab: value,
          },
        });
      },
    },
  },
  methods: {
    async fetchEventInvitations() {
      const { data, success } = await getIncomingUserInvitations();

      if (success) {
        this.eventInvitationArray = data.items;
      }
    },
    async fetchTeamInvitations() {
      const { data, success } = await getIncomingUserTeamInvitations();

      if (success) {
        this.teamInvitationArray = data.items;
      }
    },
    handleChangeTab({ name }) {
      const { activeTab } = this;

      if (name !== activeTab) {
        this.$router.push({
          route: 'Invitations',
          query: {
            tab: name,
          },
        });
      }
    },
  },
  created() {
    this.fetchEventInvitations();
    this.fetchTeamInvitations();
  },
};
</script>

<style lang="scss">
.invitations {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);
    font-weight: 500;
    font-size: var(--font-size-800);
  }
  &__list {
  }
  &__empty-text {
  }
  &__list {
  }
  &__empty-text {
  }
}
</style>
